// extracted by mini-css-extract-plugin
export var statItem = "_ds-1";
export var statsRow = "_ds-0";